// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-upgrade[data-v-57e8c43f] {\r\n  background-color: var(--carbon-900) !important;\n}\n.btn-upgrade[data-v-57e8c43f]:hover {\r\n  background-color: var(--carbon-800) !important;\n}\n.btn-upgrade[data-v-57e8c43f]:pressed {\r\n  background-color: var(--black) !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
